import { isJsonString } from "../helpers";

const TEMP_STATE_KEY = "grigora-temp-state";

const getTempStateLocalStorage = (key = false) => {
  if (!window.localStorage) {
    return null;
  }

  if (!key) {
    return null;
  }

  const value = localStorage.getItem(TEMP_STATE_KEY);

  if (value && isJsonString(value)) {
    return JSON.parse(value)?.[key] ?? null;
  }

  return null;
};

const setTempStateLocalStorage = (key = false, value) => {
  if (!window.localStorage) {
    return null;
  }

  if (!key) {
    return null;
  }

  const store = localStorage.getItem(TEMP_STATE_KEY);

  if (store && isJsonString(store)) {
    var data = JSON.parse(store);
    data[key] = value;
    localStorage.setItem(TEMP_STATE_KEY, JSON.stringify(data));
  } else {
    localStorage.setItem(
      TEMP_STATE_KEY,
      JSON.stringify({
        [key]: value,
      }),
    );
  }

  return null;
};

export { getTempStateLocalStorage, setTempStateLocalStorage };
